module.exports = __webpack_public_path__ + "9d845e84f7cb6e18d4e21ebe4af7e773.png";